import { Box, FileSelector, Icon, LoaderNew, ModBox, RadioButtonGroup, Spacer, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { isEmptyObject } from '@jfs/utils'
import { useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { BulkOnnboardResponse } from '../../data/models/Merchant'
import { useStores } from '../../data/store'
import { MessageTypes } from '../../utils'

const SQR_DATA = {
  ACTIONS: ['Pair', 'Unpair'],
  validColumns: {
    Pair: ['SQR TR NO', 'mid', 'VB DSN'],
    Unpair: ['SQR TR NO', 'mid'],
  },
  sampleFile: {
    Pair: 'sample_pair_sqr.xlsx',
    Unpair: 'sample_unpair_sqr.xlsx',
  },
  buttonTitle: {
    Pair: 'Pair SQR',
    Unpair: 'Unpair SQR',
  },
}
const { REACT_APP_ENDPOINT = '' } = window?._env_

const ManageSQRs = () => {
  const [selectedAction, setSelectedAction] = useState(SQR_DATA?.ACTIONS?.[0])
  const [loading, setLoading] = useState(false)
  const [selectedFileInfo, setSelectedFileInfo] = useState({ name: '', keys: [], values: [] })

  const { setMessage, linkOrDelinkSRQs } = useStores((store) => ({
    setMessage: store.message.setMessage,
    linkOrDelinkSRQs: store.linkOrDelinkSRQs,
  }))

  const onBulkUpload = async (apiCall: any, loaderFunc: (b: boolean) => void, fileName: string) => {
    loaderFunc(true)
    const errorData: BulkOnnboardResponse[] = await apiCall(selectedFileInfo?.values, selectedAction)
    loaderFunc(false)

    let transformedData = []
    const modifiedMidData = JSON.parse(JSON.stringify(selectedFileInfo?.values))
    modifiedMidData?.forEach((item) => {
      selectedFileInfo?.keys?.forEach((key) => {
        if (item[key as keyof typeof item] === undefined) {
          item[key as keyof typeof item] = ''
        }
      })
    })

    transformedData = errorData.map((item) => [item.status, item.message, item.code])
    transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])

    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const data: any = []
      data.push([...selectedFileInfo?.keys, ...transformedData[0]])
      modifiedMidData.map((item: any, index: number) => {
        data.push([...Object.values(item), ...transformedData[index + 1]])
      })

      workbook.sheet(0)?.cell('A1').value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })
      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = `result_${fileName}`
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  const readExcel = async (file: any, name: string) => {
    if (!file) {
      return
    }
    // setLoading(true)
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          const uniqueValues: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
              }
            }
            !isEmptyObject(obj) && values.push(obj)
          })
          let filterdObj: any = {}
          rows?.forEach((element) => {
            const key: any = element?.cell(2)?.value()
            if (!!key && !filterdObj[key]) {
              filterdObj[key] = element
            }
          })
          const filteredRows = Object.values(filterdObj)
          filteredRows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row?._cells?.length; i++) {
              if (rowIndex !== 0) {
                const key = keys[i - 1]
                obj[key] = `${row?._cells[i]?.value() ?? ''}`
              }
            }
            !isEmptyObject(obj) && uniqueValues.push(obj)
          })
          const isExcelInvalid = SQR_DATA?.validColumns?.[selectedAction]?.some((item) => !keys.includes(item))
          console.log('htag values', keys, values)
          if (!isExcelInvalid && values?.length > 0) {
            //setUsers(values)
            resolve(values)
            //setInputkeys(keys)
            setSelectedFileInfo({
              name,
              keys: keys,
              values: values,
            })
          } else {
            reject(
              isExcelInvalid
                ? 'The uploaded file contains invalid column names. Please use the template provided.'
                : 'Some required fields are empty. Please fill all values before uploading.',
            )
          }
        })
        .catch((e) => {
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setSelectedFileInfo({ name: '', keys: [], values: [] })
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  return (
    <Box flex={1} bg="WHITE" align="center" overflow={'auto'} p={16} alignItems={'center'}>
      <TextNew
        title={'Select Action for SQR'}
        fontSize={16}
        lineHeight={24}
        fontFamily="jiotype-medium"
        color="BLACK_21"
        textAlign="center"
      />

      <RadioButtonGroup
        value={selectedAction}
        data={SQR_DATA.ACTIONS}
        onChange={(data) => {
          setSelectedAction(data)
          setSelectedFileInfo({ name: '', keys: [], values: [] })
        }}
        direction="horizontal"
        size={14}
      />
      <Box
        disabled={!selectedAction}
        opacity={!selectedAction ? 0.8 : 1}
        pointerEvents={!selectedAction ? 'none' : 'auto'}>
        <FileSelector
          innerCompTitle="Please upload SQRs list file to pair/unpair"
          innnerCompSubtitle={'Browse SQR list file'}
          onFileSelect={readExcel}
          fileType=".xlsx"
          filename={selectedFileInfo?.name}
        />
        <ModBox
          show={selectedAction?.length > 0}
          flexDirection={'row'}
          justifyContent="center"
          alignSelf={'stretch'}
          flexWrap={'wrap'}>
          <ButtonNew
            isLoading={loading}
            disabled={selectedFileInfo?.values?.length === 0}
            paddingVertical={16}
            title={SQR_DATA?.buttonTitle?.[selectedAction]}
            type="primary"
            onPress={() => {
              onBulkUpload(linkOrDelinkSRQs, setLoading, selectedFileInfo?.name)
            }}
          />
        </ModBox>
        <Box justifyContent={'center'} alignItems={'center'}>
          <a
            href={`${REACT_APP_ENDPOINT}/${SQR_DATA?.sampleFile?.[selectedAction]}`}
            style={{ textDecoration: 'none', justifyContent: 'center', alignItems: 'center' }}
            rel="noopener noreferrer"
            target="_blank">
            <Box flexDirection={'row'} align={'center'}>
              <Icon id={'DOWNLOAD'} color={'PRIMARY'} />
              <Spacer size={8} direction={'horizontal'} />
              <TextNew fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY'}>
                {'Sample File'}
              </TextNew>
            </Box>
          </a>
        </Box>
        {loading && (
          <Box
            backgroundColor={'TRANSPARENT'}
            position={'absolute'}
            left={0}
            right={0}
            top={0}
            bottom={0}
            alignItems="center"
            justify="center">
            <LoaderNew color={'PRIMARY'} type="large" />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default ManageSQRs
